import { ResourcesConfig } from 'aws-amplify';

const region = process.env.REACT_APP_AWS_REGION as string;
const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID as string;
const userPoolClientId = process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID as string;

const awsConfig = {
  Auth: {
    Cognito: {
      region,
      userPoolId,
      userPoolClientId
    }
  }
} as ResourcesConfig;

export default awsConfig;
